import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=5139555e"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports